export const default_en = {
    "M2WEB Reservation System": "M2WEB Reservation System",
    "Username": "Username",
    "Username is required": "Username is required",
    "Password": "Password",
    "Password is required": "Password is required",
    "Log in": "Log in",
    "Logging in": "Logging in",
    "Log out": "Log out",
    "Session Expired, Please Login": "Session Expired, Please Login",
    "Reservation Data": "Reservation Data",
    "Check Queue": "Check Queue",
    "Loading": "Loading",
    "Site": "Site",
    "Channel": "Channel",
    "All Queue Reservations": "All Queue Reservations",
    "Queue Reservations": "Queue Reservations",
    "Queue And Canceled Queue Reservations": "Queue And Canceled Queue Reservations",
    "Canceled Queue Reservations": "Canceled Queue Reservations",
    "Reserve Queue": "Reserve Queue",
    "Show Remaining Queues": "Remaining Queus",
    "Show All Queues By Specifying Time Interval": "Show All Queues By Specifying Time Interval",
    "From": "From",
    "To": "To",
    "Get Data": "Get Data",
    "Site Name": "Site Name",
    "Queue Slot": "Queue Slot",
    "Reserved No": "Reserved No",
    "Registration No": "Registration No",
    "Truck Type": "Truck Type",
    "Create By": "Create By",
    "Material": "Material",
    "Release Time": "Release Time",
    "Register Date": "Register Date",
    "Finished Date": "Finished Date",
    "License Plate": "License Plate",
    "Queue Status": "Queue Status",
    "Region": "Region",
    "Supplier": "Supplier",
    "PO No": "PO No",
    "Remark": "Remark",
    "Insert Date": "Insert Date",
    "Back": "Back",
    "Version": "Version",
    "Edit Queue": "Edit Queue",
    "Failed to load site data": "Failed to load site data",
    "Failed to load channel data": "Failed to load channel data",
    "Failed to load data for reserve queue": "Failed to load data for reserve queue",
    "Failed to load canceled queue data": "Failed to load canceled queue data",
    "Failed to load queue data": "Failed to load queue data",
    "Queue canceled successfully": "Queue canceled successfully",
    "Failed to cancel queue": "Failed to cancel queue",
    "Queue Detail": "Queue Detail",
    "Appointment Date": "Appointment Date",
    "Close": "Close",
    "Save data successfully": "Save data successfully",
    "Failed to save data": "Failed to save data",
    "Edit Queue": "Edit Queue",
    "Save": "Save",
    "Reserve New Queue": "Reserve New Queue",
    "Login failed": "Login failed",
    "Reserve Queue Success": "Reserve Queue Success",
    "Failed to reserve queue": "Failed to reserve queue",
    "Choose your language": "Choose your language",
    "Edit Queue": "Edit Queue",
    "Queue Detail And QRCode": "Queue Detail And QRCode",
    "Cancel Queue": "Cancel Queue",
}